module.exports = __webpack_public_path__ + "static/404-17b09dcf4c173ea023ec0fa12d78134a.svg";